import {SourceSection} from "../../../types/SourceSection";
import {View} from "../../km_app/types/View";
import {ApplicationSourceSection} from "../../lead/types/ApplicationSourceSection";
import {PropertyListType} from "../types/IPropertyListType";
import {IPropertyState} from "../types/IPropertyState";

export const propertyOneClickLeadModalInitialState: IPropertyState["oneClickLeadModal"] = {
    isOpen: false,
    itemId: 0,
    itemType: PropertyListType.Recommendation,
    applicationSourceSection: ApplicationSourceSection.PropertyModalOneClickLeadMobileModal,
    sourceSection: SourceSection.PropertyDetailModalSidebar,
    viewType: View.MY_OFFER
};
import {SourceSection} from "../../../types/SourceSection";
import {View} from "../../km_app/types/View";
import {ApplicationSourceSection} from "../../lead/types/ApplicationSourceSection";
import {PropertyListType} from "../types/IPropertyListType";
import {IPropertyState} from "../types/IPropertyState";

export const propertyOneClickLeadModalInitialState: IPropertyState["oneClickLeadModal"] = {
    isOpen: false,
    itemId: 0,
    itemType: PropertyListType.Recommendation,
    applicationSourceSection: ApplicationSourceSection.PropertyModalOneClickLeadMobileModal,
    sourceSection: SourceSection.PropertyDetailModalSidebar,
    viewType: View.MY_OFFER
};
